import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckoutInqqComponent } from './checkout-inqq.component';
import { CheckoutDetailsComponent } from './checkout-details/checkout-details.component';
import { BookingDetailsComponent } from './booking-details/booking-details.component';


const routes: Routes = [
  { path: '', component: CheckoutInqqComponent},
  { path: 'checkout/:id/:userid', component: CheckoutDetailsComponent, },
  { path:'booking-details/:req_ID/:userID', component: BookingDetailsComponent, },
  // { path: 'checkout', component: CheckoutDetailsComponent, },

  // { path: 'checkout/booking-details', component: BookingDetailsComponent, },





];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class checkoutRoutingModule { }

